import { new__cn as cn } from '@/component/UI/util';

import {
  TW_BUTTON_BASE,
  TW_BUTTON_VARIANT,
  TW_OUTLINED_BUTTON,
} from '../VButton';
import createTwStyle from '../util/createTwStyle';
import { ICON_BUTTON_SIZE, ICON_BUTTON_VARIANT } from './constant';
import type { VIconButtonProps } from './type';

export const TW_ICON_ROUND_BUTTON = cn(
  'bg-white',
  'rounded-full!',
  'enabled:active:bg-tertiary-200',
);

export const TW_ICON_BUTTON_SIZE = {
  [ICON_BUTTON_SIZE.EXTRA_SMALL]: cn('size-5', 'rounded-sm', '[&_svg]:size-3'),
  [ICON_BUTTON_SIZE.SMALL]: cn('size-6.5', 'rounded-sm', '[&_svg]:size-4'),
  [ICON_BUTTON_SIZE.MEDIUM]: cn('size-7.5', 'rounded-md', '[&_svg]:size-4'),

  [ICON_BUTTON_SIZE.XS]: cn('size-5', 'rounded-sm', '[&_svg]:size-3'),
  [ICON_BUTTON_SIZE.SM]: cn('size-6.5', 'rounded-sm', '[&_svg]:size-4'),
  [ICON_BUTTON_SIZE.MD]: cn('size-7.5', 'rounded-md', '[&_svg]:size-4'),
  [ICON_BUTTON_SIZE.LG]: cn('size-10', 'rounded-md', '[&_svg]:size-7'),
} as const;

export const TW_ICON_BUTTON_VARIANT = {
  [ICON_BUTTON_VARIANT.PRIMARY]: cn(TW_BUTTON_VARIANT.primary),
  [ICON_BUTTON_VARIANT.SECONDARY]: cn(TW_BUTTON_VARIANT.secondary),
  [ICON_BUTTON_VARIANT.DANGER]: cn(TW_BUTTON_VARIANT.danger),
  [ICON_BUTTON_VARIANT.CANCEL]: cn(TW_BUTTON_VARIANT.cancel),

  [ICON_BUTTON_VARIANT.DANGER_OUTLINE]: cn(TW_BUTTON_VARIANT.dangerOutline),

  [ICON_BUTTON_VARIANT.ROUND_PRIMARY]: cn(
    TW_ICON_ROUND_BUTTON,
    'text-primary-500',

    'enabled:hover:text-primary-400',

    'enabled:active:text-primary-600',
  ),
  [ICON_BUTTON_VARIANT.ROUND_SECONDARY]: cn(
    TW_ICON_ROUND_BUTTON,
    'text-secondary-500',

    'enabled:hover:text-secondary-400',

    'enabled:active:text-secondary-600',
  ),
  [ICON_BUTTON_VARIANT.ROUND_DANGER]: cn(
    TW_ICON_ROUND_BUTTON,
    'text-error-500',

    'enabled:hover:text-error-400',

    'enabled:active:text-error-500',
  ),
  [ICON_BUTTON_VARIANT.ROUND_CANCEL]: cn(
    TW_ICON_ROUND_BUTTON,
    'text-gray-500',

    'enabled:hover:text-gray-400',

    'enabled:active:text-gray-600',
  ),

  [ICON_BUTTON_VARIANT.TRANSPARENT]: 'bg-none border border-transparent',
} as const;

export const TW_ICON_BUTTON_BASE = cn(TW_BUTTON_BASE);

export const TW_OUTLINE_ICON_BUTTON_BASE = cn(TW_OUTLINED_BUTTON);

const twStyle =
  createTwStyle<Pick<VIconButtonProps, 'outlined' | 'size' | 'variant'>>();

export default twStyle({
  iconButton: ({
    outlined = false,
    size = ICON_BUTTON_SIZE.MD,
    variant = ICON_BUTTON_VARIANT.PRIMARY,
  }) => {
    return cn(
      TW_ICON_BUTTON_BASE,
      TW_ICON_BUTTON_SIZE[size],
      TW_ICON_BUTTON_VARIANT[variant],
      outlined ? TW_OUTLINE_ICON_BUTTON_BASE : '',
    );
  },
});
